import React, {Component} from 'react';
import {
  Button,
  Table
} from 'reactstrap';


import { FaPencilAlt, FaTrashAlt} from 'react-icons/fa';

class TablaCiclos extends Component {

    render(){
        const {data, eliminar, editar} = this.props; 
        return (
            <div>
            {data.length>0 ? 
                   (
                        <Table size="sm" striped bordered className="tabla-general">

                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Descripción</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>

                            {data.map(c => {
                                return (
                                    <tr key={c.id}>
                                        <td>{c.nombre}</td>
                                        <td>{c.descripcion}</td>
                                        <td className="text-center td-botones">
                                            <Button color="secondary" className="btn-tabla" onClick={()=>editar(c)} > <FaPencilAlt/></Button>
                                            <Button color="danger" className="btn-tabla" onClick={()=>eliminar(c.id)} ><FaTrashAlt/></Button>
                                        </td>
                                    </tr>
                                )  
                            })}


                            </tbody>

                        </Table>   
                      ) : (<div className="sin-registros">Sin registros</div>)
                   
                   }
           </div>
 
                 

        );

    }
};

export default TablaCiclos;
